import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=782c4aaa&scoped=true&"
import script from "./EditorWrapper.vue?vue&type=script&lang=js&"
export * from "./EditorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EditorWrapper.vue?vue&type=style&index=0&id=782c4aaa&scoped=true&lang=scss&"
import style1 from "./EditorWrapper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782c4aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/nextcloud/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782c4aaa')) {
      api.createRecord('782c4aaa', component.options)
    } else {
      api.reload('782c4aaa', component.options)
    }
    module.hot.accept("./EditorWrapper.vue?vue&type=template&id=782c4aaa&scoped=true&", function () {
      api.rerender('782c4aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/text/src/components/EditorWrapper.vue"
export default component.exports